export const getDefaultValues = (values) =>
  Object.entries(values).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = { value, code: key };
    }
    return acc;
  }, {});

export const getItemCode = (item) =>
  item?.code || item?.tile?.code || item?.itemCode || '';

export const trimString = (description, requiredLength) => {
  const trimmedString =
    description.length > requiredLength
      ? description.substring(0, requiredLength - 3).concat('...')
      : description;
  return trimmedString;
};

export const getInputValuesMap = (inputs) =>
  inputs.reduce((acc, { code, value }) => {
    if (value) {
      acc[code] = { value, code };
    }
    return acc;
  }, {});
